import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BaseText = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(2, 1.25),
  backgroundColor: theme.palette.grey[100],
  wordBreak: 'break-word',
  borderRadius: '16px 16px 16px 0px',
  color: 'initial',
}));
